export function unwrapDashboardRoot<T>(body: unknown, rootKey: string): T | null {
  if (body == null) return null;
  if (typeof body === 'object' && rootKey in body) {
    return (body as Record<string, unknown>)[rootKey] as T;
  }
  return body as T;
}
